import { Emitter, type Event } from '@patsnap/tahiti-core';

export interface AttachmentAddedEvent {
    projectId: string;
    fileId: string;
    fileName: string;
    category: string;
    signedUrl: string;
    fileSize: number;
    fileType: string;
    toolName: string;
    turnId?: string;
}

export interface AttachmentEventSource {
    readonly onAdded: Event<AttachmentAddedEvent>;
}

export interface AttachmentEventPublisher {
    /** 发布项目内附件新增事实。 */
    publishAdded(event: AttachmentAddedEvent): void;
}

/** 创建可隔离测试的附件领域事件服务。 */
export function createAttachmentEvents(): AttachmentEventSource & AttachmentEventPublisher {
    const addedEmitter = new Emitter<AttachmentAddedEvent>({
        onListenerError: error => console.error('[AttachmentEvents] listener failed:', error),
    });
    return {
        onAdded: addedEmitter.event,
        publishAdded: event => addedEmitter.fire(event),
    };
}

/** 应用级附件领域事件服务；后续由 composition root 统一装配。 */
export const attachmentEvents = createAttachmentEvents();
